import { createContext, ReactNode, RefObject, useContext } from 'react'
import { RfModal } from '@vibialighting/ui-kit'
import useModal from '../hooks/useModal'

type ModalContextType = {
	modalContent: ReactNode
	modalOpen: boolean
	modalMount: (content: ReactNode) => void
	modalProps: any // Cuando el componente modal del UiKit se pase a Typescript, cambiar el any por el tipo de las props que se exponga desde ahí.
	modalRef: RefObject<HTMLElement> | undefined
	modalUnmount: (forceRerender?: boolean) => void
}

type ModalProviderProps = {
	children: ReactNode
}

export const ModalContext = createContext<ModalContextType>({
	modalContent: null,
	modalOpen: false,
	modalProps: {},
	modalRef: undefined,
	modalMount: () => { },
	modalUnmount: () => { }
})

const ModalBase = () => {
	const { modalContent, modalOpen, modalProps, modalRef, modalUnmount } = useContext<ModalContextType>(ModalContext)
	const handleClose = (modalProps?: any) => {
		let forceRerender = false
		if (modalProps?.authViewParams?.siteLocation == "TSSAlert") {
			forceRerender = true
		}
		modalUnmount(forceRerender)
	}

	return (
		<RfModal open={modalOpen} onClose={() => handleClose(modalProps)} {...modalProps} ref={modalRef}>
			{modalContent}
		</RfModal>
	)
}

export const ModalProvider = (props: ModalProviderProps) => {
	const { children } = props

	const { modalContent, modalMount, modalOpen, modalProps, modalRef, modalUnmount } = useModal()

	return (
		<ModalContext.Provider
			value={{
				modalContent,
				modalMount,
				modalOpen,
				modalProps,
				modalRef,
				modalUnmount
			}}
		>
			{children}
			<ModalBase />
		</ModalContext.Provider>
	)
}

export const useModalContext = () => useContext(ModalContext)
